import config from "@/config";
import { LogtoConfig } from "@logto/react";

export const authConfig: LogtoConfig = {
  endpoint: config.LOGTO_ENDPOINT,
  appId: config.LOGTO_APP_ID,
  resources: [config.LOGTO_RESOURCE],
};
